import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide01EntryHook from './slides/Slide01EntryHook'
import Slide02UsedToBeObvious from './slides/Slide02UsedToBeObvious'
import Slide03NotAnymore from './slides/Slide03NotAnymore'
import Slide04AiRevolution from './slides/Slide04AiRevolution'
import Slide05YouveNoticed from './slides/Slide05YouveNoticed'
import Slide06Why from './slides/Slide06Why'
import Slide07SpotAi from './slides/Slide07SpotAi'
import Slide08WhatWant from './slides/Slide08WhatWant'
import Slide09SameGoals from './slides/Slide09SameGoals'
import Slide10NotJustFinancial from './slides/Slide10NotJustFinancial'
import Slide11EmotionalToll from './slides/Slide11EmotionalToll'
import Slide12GoodNewsTitle from './slides/Slide12GoodNewsTitle'
import Slide13LittleTraining from './slides/Slide13LittleTraining'
import Slide14DefenseSystem from './slides/Slide14DefenseSystem'
import Slide15WhatsNext from './slides/Slide15WhatsNext'

// Chapter 1: The New Age of Scams. Converted from PathWizard (path.ts) to
// SlideWizard on 2026-04-24. Slide IDs match the original v1 node IDs so
// existing user progress records remain valid across the migration.
export const landscapeOfDeceptionChapter: SlideChapterDefinition = {
  id: 'landscape-of-deception',
  title: 'The New Age of Scams',
  description:
    'How scams have evolved into a professional industry, and why the old warning signs no longer work.',
  estimatedMinutes: 9,
  slides: [
    { id: 'lod-entry-hook', component: Slide01EntryHook, label: 'Introduction' },
    { id: 'lod-used-to-be-obvious', component: Slide02UsedToBeObvious, label: 'Scams used to be obvious' },
    { id: 'lod-not-anymore', component: Slide03NotAnymore, label: 'Not anymore' },
    { id: 'lod-ai-revolution', component: Slide04AiRevolution, label: 'Scammers have gone pro' },
    { id: 'lod-youve-noticed', component: Slide05YouveNoticed, label: "You've seen it yourself" },
    { id: 'lod-why', component: Slide06Why, label: 'Why do they do it?' },
    { id: 'lod-spot-ai', component: Slide07SpotAi, label: 'Because it works' },
    { id: 'lod-what-want', component: Slide08WhatWant, label: 'What are scammers after?' },
    { id: 'lod-call-centre', component: Slide09SameGoals, label: 'Different stories, same goals' },
    { id: 'lod-not-just-financial', component: Slide10NotJustFinancial, label: 'Not just financial' },
    { id: 'lod-emotional-toll', component: Slide11EmotionalToll, label: 'The hidden emotional toll' },
    { id: 'lod-good-news-title', component: Slide12GoodNewsTitle, label: 'The good news?' },
    { id: 'lod-reporting-guess', component: Slide13LittleTraining, label: 'A little training goes a long way' },
    { id: 'lod-our-approach', component: Slide14DefenseSystem, label: 'Your defense system' },
    { id: 'lod-whats-next', component: Slide15WhatsNext, label: 'Chapter summary' },
  ],
}
